import { DataTable, DataTableData } from "@/src/components/ui/data-table";
import { useEffect, useState } from "react";
import { Country } from "./model";
import { useSearch, usePageSize } from "./state";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/src/lib/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import { extractFromMultiName } from "./utils";

export function CountriesTable() {
  const [countries, setCountries] = useState<DataTableData<Country>>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 1 },
  });
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
  const search = useSearch();
  const pageSize = usePageSize();
  const { fetch } = useFetch();

  useEffect(() => {
    const fetchCountries = (page: number) =>
      fetch<DataTableData<Country>>(`/api/locations/countries?page=${page}&pageSize=${pageSize}&filter=${search}`);

    fetchCountries(page).then((data) => {
      setCountries(data);
    });
  }, [page, search, pageSize]);

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-md bg-white border">
        <DataTable
          columns={countriesColumns}
          pagination={countries}
          data={countries.data}
          onPageClick={setPage}
          onRowClick={(r) => navigate(`/locations/countries/${r.id}`)}
        />
      </div>
    </div>
  );
}

export const countriesColumns: ColumnDef<Country>[] = [
  {
    header: "Name",
    accessorFn: (c) => extractFromMultiName(c.names),
  },
  {
    header: "Code",
    accessorFn: (c) => c.code,
  },
  {
    header: "Top-Level Region",
    accessorFn: (c) => extractFromMultiName(c.tlr?.names, "N/A"),
  },
];
